import { v4 as uuid } from '@lukeed/uuid'

const GOOGLE_NONCE_KEY = 'google_nonce'

/*
 * We manage a nonce (crypto random uuid) in session storage so that it survives
 * page redirects to/from the Google OAuth flow.
 * The nonce is added to the state so that it can be validated against the resulting
 * callback. This guards against a reversed CSRF exploit, where a user can be tricked
 * into operating on an attacker's account.
 */
const GOOGLE_NONCE_METHODS = {
  clear: () => sessionStorage.removeItem(GOOGLE_NONCE_KEY),
  get: (): string | null => sessionStorage.getItem(GOOGLE_NONCE_KEY),
  set: (value: string) => sessionStorage.setItem(GOOGLE_NONCE_KEY, value)
}

export function createGoogleNonce() {
  const nonce = uuid()
  GOOGLE_NONCE_METHODS.set(nonce)
  return nonce
}

function consumeGoogleNonce() {
  const nonce = GOOGLE_NONCE_METHODS.get()
  GOOGLE_NONCE_METHODS.clear()
  return nonce
}

/**
 * Validate nonce against the one we generated at login
 * @throws Error if stored nonce is missing or input does not match the stored nonce
 */
export function validateGoogleNonce(nonce: string | undefined) {
  const expectedNonce = consumeGoogleNonce()

  if (!expectedNonce) {
    throw new Error('Google auth request not able to be validated')
  }
  if (nonce !== expectedNonce) {
    throw new Error('Google auth response failed validation')
  }
}
